import {
  ChangeDetectionStrategy,
  Component,
  effect,
  inject,
  input,
} from '@angular/core';
import { DialogService } from 'primeng/dynamicdialog';
import { Skeleton } from 'primeng/skeleton';
import { CARE_PLAN_DIALOG_OPTIONS } from '../../care-plan-dialog.options';
import { CarePlanCardListComponent } from '../../shared/care-plan-card-list/care-plan-card-list.component';
import { OptionCardComponent } from '../option-card/option-card.component';
import {
  OptionEditorDialogComponent,
  OptionEditorDialogData,
} from '../option-editor-dialog/option-editor-dialog.component';
import { CarePlanOptionsStore } from '../options.store';

@Component({
  selector: 'bn-options-section',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [CarePlanCardListComponent, OptionCardComponent, Skeleton],
  providers: [CarePlanOptionsStore, DialogService],
  templateUrl: './options-section.component.html',
  styleUrl: './options-section.component.scss',
})
export class OptionsSectionComponent {
  private readonly _dialog = inject(DialogService);
  protected readonly store = inject(CarePlanOptionsStore);

  readonly caseId = input.required<string>();
  readonly readonly = input(false);

  constructor() {
    effect(() => {
      const caseId = this.caseId();
      if (caseId) void this.store.load(caseId);
    });
  }

  openAdd(): void {
    if (this.readonly()) return;
    this._dialog.open(OptionEditorDialogComponent, {
      ...CARE_PLAN_DIALOG_OPTIONS,
      width: '42rem',
      breakpoints: { '768px': 'calc(100vw - 2rem)' },
      styleClass: 'bn-option-editor-dialog-host',
      ariaLabelledBy: 'option-editor-dialog-title',
      data: {
        mode: 'add',
        store: this.store,
      } satisfies OptionEditorDialogData,
    });
  }
}
